(function () {
  var instances = {};

  // Pin the version we ship. Only used as a fallback if nothing else on the
  // page has already loaded Swiper — we never load a second copy on top of
  // one that's already there, since two versions fighting over
  // `window.Swiper` is what breaks other sliders on the page.
  var SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
  var SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';

  function alreadyTagged(selectorFragment) {
    return !!document.querySelector('script[src*="' + selectorFragment + '"], link[href*="' + selectorFragment + '"]');
  }

  // Ensures Swiper is available exactly once, no matter how many sections
  // (ours or a theme/app's own slider) ask for it concurrently.
  function ensureSwiper() {
    if (window.Swiper) {
      return Promise.resolve(window.Swiper);
    }

    if (window.__shopifySwiperLoader) {
      return window.__shopifySwiperLoader;
    }

    window.__shopifySwiperLoader = new Promise(function (resolve, reject) {
      // Something else on the page is already loading Swiper (script tag
      // exists but hasn't finished executing yet) — wait for it instead of
      // injecting a duplicate.
      if (alreadyTagged('swiper')) {
        var attempts = 0;
        var poll = setInterval(function () {
          attempts++;
          if (window.Swiper) {
            clearInterval(poll);
            resolve(window.Swiper);
          } else if (attempts > 100) { // ~10s
            clearInterval(poll);
            reject(new Error('Swiper did not become available'));
          }
        }, 100);
        return;
      }

      if (!alreadyTagged('swiper-bundle.min.css') && !document.querySelector('link[href*="swiper"]')) {
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = SWIPER_CSS;
        document.head.appendChild(link);
      }

      var script = document.createElement('script');
      script.src = SWIPER_JS;
      script.onload = function () {
        resolve(window.Swiper);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return window.__shopifySwiperLoader;
  }

  function initTestimonialSlider(container) {
    if (!container) return;

    var sectionId = container.dataset.sectionId;
    var swiperEl = container.querySelector('.testimonial-swiper');
    if (!swiperEl) return;

    ensureSwiper().then(function (SwiperCtor) {
      if (!SwiperCtor) return;

      // Destroy any existing instance for this section before re-initializing
      // (needed when the theme editor re-renders the section on setting changes).
      if (instances[sectionId]) {
        instances[sectionId].destroy(true, true);
        delete instances[sectionId];
      }

      var autoplayEnabled = container.dataset.autoplay === 'true';
      var loopEnabled = container.dataset.loop === 'true';
      var autoplaySpeed = parseInt(container.dataset.autoplaySpeed, 10) || 4000;
      var slidesDesktop = parseInt(container.dataset.slidesDesktop, 10) || 3;
      var slidesTablet = parseInt(container.dataset.slidesTablet, 10) || 2;
      var slidesMobile = parseInt(container.dataset.slidesMobile, 10) || 1;

      var config = {
        slidesPerView: slidesMobile,
        spaceBetween: 24,
        loop: loopEnabled,
        grabCursor: true,
        watchOverflow: true,
        breakpoints: {
          750: { slidesPerView: slidesTablet },
          990: { slidesPerView: slidesDesktop }
        },
        pagination: {
          el: container.querySelector('.testimonial-slider__pagination'),
          clickable: true
        },
        navigation: {
          nextEl: container.querySelector('.testimonial-slider__nav--next'),
          prevEl: container.querySelector('.testimonial-slider__nav--prev')
        },
        a11y: { enabled: true }
      };

      if (autoplayEnabled) {
        config.autoplay = {
          delay: autoplaySpeed,
          pauseOnMouseEnter: true,
          disableOnInteraction: false
        };
      }

      instances[sectionId] = new SwiperCtor(swiperEl, config);
    });
  }

  function initAll() {
    document.querySelectorAll('.testimonial-slider').forEach(initTestimonialSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify theme editor support: re-init on section load, clean up on unload.
  document.addEventListener('shopify:section:load', function (event) {
    var container = event.target.querySelector('.testimonial-slider');
    if (container) initTestimonialSlider(container);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var container = event.target.querySelector('.testimonial-slider');
    if (!container) return;
    var sectionId = container.dataset.sectionId;
    if (instances[sectionId]) {
      instances[sectionId].destroy(true, true);
      delete instances[sectionId];
    }
  });
})();
